import { render, staticRenderFns } from "./NoticeIndex.vue?vue&type=template&id=24bf7c19&scoped=true"
import script from "./NoticeIndex.vue?vue&type=script&lang=js"
export * from "./NoticeIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bf7c19",
  null
  
)

export default component.exports